"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageContainer = exports.mapSearchResults = exports.mapArticleResources = exports.mapMegamenuItems = exports.extractProducts = exports.extractArticles = exports.LinkSection = exports.ProductResultsSection = exports.NoResultsFound = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_notification_1 = require("@ryerson/frontend.notification");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var SearchResultItem_v2_1 = __importDefault(require("./SearchResultItem_v2"));

var StyledComponents_1 = require("../Footer/Helpers/StyledComponents");

var react_1 = __importDefault(require("react"));

var SearchResultsContext_v2_1 = require("./SearchResultsContext_v2");

var SearchResultsTypes_v2_1 = require("./SearchResultsTypes_v2");

var SearchResults_v2_1 = require("./SearchResults_v2");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_2 = require("@emotion/react");

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var NoResultsFound = function NoResultsFound(_ref) {
  var label = _ref.label;
  return (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
    children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      justifyContent: "center",
      css: {
        height: "150px"
      },
      children: (0, jsx_runtime_1.jsx)(frontend_notification_1.Alert, {
        severity: "warn",
        size: "sm",
        children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          type: "primary",
          size: "sm",
          children: label
        })
      })
    })
  });
};

exports.NoResultsFound = NoResultsFound;

var ProductResultsSection = function ProductResultsSection(_ref2) {
  var items = _ref2.items,
      sectionTitle = _ref2.sectionTitle,
      sliceSize = _ref2.sliceSize,
      isRecentlyPurchased = _ref2.isRecentlyPurchased;

  var _ref3 = (0, frontend_theme_1.useTheme)(),
      theme = _ref3.theme;

  var _theme$colors$primary = theme.colors.primary,
      text = _theme$colors$primary.text,
      lighterGray = _theme$colors$primary.lighterGray;

  var _ref4 = (0, SearchResultsContext_v2_1.useSearchResults)(),
      isMobile = _ref4.isMobile;

  return (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
    children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      direction: "column",
      css: {
        background: lighterGray
      },
      children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        css: {
          paddingBottom: 10
        },
        weight: "bold",
        size: "xs",
        children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          css: {
            gap: 5,
            alignItems: "center"
          },
          children: [isRecentlyPurchased && (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            icon: "history",
            size: "xs"
          }), sectionTitle]
        })
      }), items === null || items === void 0 ? void 0 : items.slice(0, sliceSize).map(function (item, index) {
        return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
          children: [(0, jsx_runtime_1.jsx)(SearchResultItem_v2_1.default, {
            isMobile: isMobile,
            item: item
          }, item.id), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
            css: {
              paddingRight: 10
            },
            children: (0, jsx_runtime_1.jsx)(StyledComponents_1.Divider, {
              color: text,
              css: {
                width: "100%",
                marginTop: 0,
                marginBottom: 10,
                borderTop: "0.5px"
              }
            })
          })]
        }, index);
      })]
    })
  });
};

exports.ProductResultsSection = ProductResultsSection;

var LinkSection = function LinkSection(_ref5) {
  var showMoreProducts = _ref5.showMoreProducts,
      label = _ref5.label;

  var _ref6 = (0, frontend_theme_1.useTheme)(),
      theme = _ref6.theme;

  var _theme$colors$primary2 = theme.colors.primary,
      header = _theme$colors$primary2.header,
      link = _theme$colors$primary2.link,
      background = _theme$colors$primary2.background;

  var _ref7 = (0, SearchResultsContext_v2_1.useSearchResults)(),
      isGatsbyLinkType = _ref7.isGatsbyLinkType;

  return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
    children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      justifyContent: "flex-start",
      alignItems: "center",
      css: {
        gap: 6
      },
      children: (0, jsx_runtime_1.jsxs)(frontend_navigation_1.Link, {
        gatsby: isGatsbyLinkType(true),
        to: showMoreProducts(),
        css: {
          textDecoration: "none"
        },
        children: [(0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
          onClick: showMoreProducts,
          css: {
            backgroundColor: link,
            marginRight: 5
          },
          icon: "chevron-right",
          size: "md",
          circled: true,
          color: background
        }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "sm",
          color: header,
          underline: false,
          children: label
        })]
      })
    })
  });
};

exports.LinkSection = LinkSection;
/**
 * Pull `theGauge`, `locations`, and `other` articles from the search results.
 * typically:
 * ```typescript
 * const articles_theGauge = results?.articlesResources?.filter((article) => article.category === "blog") || [];
 * ```
 */

function extractArticles(results) {
  var _a;

  var articles_theGauge = [];
  var articles_locations = [];
  var articles_other = [];
  (_a = results === null || results === void 0 ? void 0 : results.articlesResources) === null || _a === void 0 ? void 0 : _a.forEach(function (article) {
    var category = article.category;

    if (category === SearchResults_v2_1.ArticleTypes.theGauge) {
      articles_theGauge.push(article);
    } else if (category === SearchResults_v2_1.ArticleTypes.location) {
      articles_locations.push(article);
    } else {
      articles_other.push(article);
    }
  });
  return {
    articles_theGauge: articles_theGauge,
    articles_locations: articles_locations,
    articles_other: articles_other
  };
}

exports.extractArticles = extractArticles;
/**
 * Pull the `matching products`, `recently purchased`, and `megamenu products` from the search results.
 * typically:
 * ```typescript
 * const matchingProducts = results?.matchingProducts ?? [];
 * ```
 */

function extractProducts(results) {
  var _a, _b, _c;

  var matchingProducts = (_a = results === null || results === void 0 ? void 0 : results.matchingProducts) !== null && _a !== void 0 ? _a : [];
  var recentlyPurchased = (_b = results === null || results === void 0 ? void 0 : results.recentlyPurchased) !== null && _b !== void 0 ? _b : [];
  var megaMenuProducts = (_c = results === null || results === void 0 ? void 0 : results.megaMenuProducts) !== null && _c !== void 0 ? _c : [];
  return {
    recentlyPurchased: recentlyPurchased,
    megaMenuProducts: megaMenuProducts,
    matchingProducts: matchingProducts
  };
}

exports.extractProducts = extractProducts;
/**
 * Map the megamenu categories to match the interface of the ResourceSectionProps.
 * This is so we can reuse the ResourceSection component.
 */

function mapMegamenuItems(
/**
 * Since OnClick and storeDirectory all point to the same place for now, use a prototype
 */
ResourceSectionPrototype, content, megaMenuProducts, storeDirectory) {
  return Object.assign(Object.assign({}, ResourceSectionPrototype), {
    titleLabel: content.productCategory,
    linkLabel: content.moreInProductCategories,
    articles: megaMenuProducts === null || megaMenuProducts === void 0 ? void 0 : megaMenuProducts.map(function (product, index) {
      return {
        blogCategory: "",
        category: "",
        excerpt: "",
        image: "",

        /**
         * Make sure to remove the `/store` from the linkUrl
         * since it will be handled by the `Link` component.
         */
        link: storeDirectory === "" ? product.linkUrl.replace(/^\/store/g, "") : product.linkUrl,
        title: "".concat(product.productCategoryLabel, " ").concat(product.megaMenuLinkLabel).toUpperCase()
      };
    }),
    urlHashTab: SearchResultsTypes_v2_1.UrlHashTabs.ProductCategory
  });
}

exports.mapMegamenuItems = mapMegamenuItems;
/**
 * Map the article resources from `theGauge`, `Locations`, and `Other` to match the interface of the {@link ResourceSectionProps}.
 */

function mapArticleResources(articles_theGauge, content, articles_locations, articles_other, showMoreProducts, storeDirectory) {
  return [{
    articles: articles_theGauge,
    titleLabel: content.gauge,
    linkLabel: content.moreInGauge,
    urlHashTab: SearchResultsTypes_v2_1.UrlHashTabs.TheGauge
  }, {
    articles: articles_locations,
    titleLabel: content.locations,
    linkLabel: content.moreInLocations,
    urlHashTab: SearchResultsTypes_v2_1.UrlHashTabs.Locations
  }, {
    articles: articles_other,
    titleLabel: content.other,
    linkLabel: content.moreInOther,
    urlHashTab: SearchResultsTypes_v2_1.UrlHashTabs.Other
  }].map(function (entry) {
    return (// Since this is not a nested object,
      // spread operator’s shallow copy is fine.
      Object.assign({
        showMoreProducts: showMoreProducts,
        storeDirectory: storeDirectory
      }, entry)
    );
  });
}

exports.mapArticleResources = mapArticleResources;
/**
 * Convert the search’s `results` into the format to be displayed by the `SearchResults_v2` component.
 *
 * This helper pulls the `results`, `content`, etc. from the {@link SearchResultsContext}.
 *
 * The break-down of sections in the `SearchResults_v2` component is as follows:
 * 1. Recently Purchased
 * 2. Matching Products
 * 3. Articles
 * 4. Categories
 * 5. Other
 */

function mapSearchResults(context) {
  var isLoggedIn = context.isLoggedIn,
      results = context.results,
      content = context.content,
      showMoreProducts = context.showMoreProducts,
      storeDirectory = context.storeDirectory;

  var _extractArticles = extractArticles(results),
      articles_theGauge = _extractArticles.articles_theGauge,
      articles_locations = _extractArticles.articles_locations,
      articles_other = _extractArticles.articles_other;

  var _extractProducts = extractProducts(results),
      recentlyPurchased = _extractProducts.recentlyPurchased,
      megaMenuProducts = _extractProducts.megaMenuProducts,
      matchingProducts = _extractProducts.matchingProducts;

  var hasRecentlyPurchasedItems = !!isLoggedIn && recentlyPurchased.length > 0;
  var articleResources = mapArticleResources(articles_theGauge, content, articles_locations, articles_other, showMoreProducts, storeDirectory);
  var mappedMegamenu = mapMegamenuItems({
    showMoreProducts: showMoreProducts,
    storeDirectory: storeDirectory
  }, content, megaMenuProducts, storeDirectory);
  return {
    recentlyPurchased: recentlyPurchased,
    matchingProducts: matchingProducts,
    hasRecentlyPurchasedItems: hasRecentlyPurchasedItems,
    articleResources: articleResources,
    mappedMegamenu: mappedMegamenu
  };
}

exports.mapSearchResults = mapSearchResults;
exports.ImageContainer = styled_1.default.img(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\theight: 48px;\n\twidth: 48px;\n\tobject-fit: contain;\n\t", ";\n"])), function (props) {
  var breakpoint = props.breakpoint,
      bgColor = props.bgColor;
  return (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t\t@media only screen and (max-width: ", ") {\n\t\t\t\theight: 60px;\n\t\t\t\twidth: 60px;\n\t\t\t}\n\t\t"])), bgColor, breakpoint);
});